export default "__VITE_ASSET__dae0ad2c__"